import React from "react";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import ApartmentIcon from "@material-ui/icons/Apartment";
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
function AddressTypeSelectNew({
  language,
  selectedAddressType,
  onChangeAddressType,
}) {
  const buttonStyle = {
    lineHeight: 3,
    textTransform: "none",
    fontWeight: "bold",
    boxShadow: "none",
    borderRadius: 3,
    padding: "2px 10px",
    fontSize: "1rem",
    width: "100%",
    display: "flex",
    alignItems: "center",
  };

  const addressTypes = {
    Home: {
      type: 0,
      ar: "منزل",
      onClick: () => onChangeAddressType(0),
      icon: <HomeIcon />,
    },
    Apartment: {
      type: 1,
      ar: "شقة",
      onClick: () => onChangeAddressType(1),
      icon: <ApartmentIcon />,
    },
    Office: {
      type: 2,
      ar: "مكتب",
      onClick: () => onChangeAddressType(2),
      icon: <BusinessCenterIcon />,
    },
  };
  const buttons = Object.keys(addressTypes).map((at) => (
    <div
      style={{
        width: "144px",
        height: "42px",
        marginRight: 5,
        marginLeft: 5,
      }}
    >
      <Button
        color="primary"
        variant={
          selectedAddressType === addressTypes[at].type ? "contained" : "none"
        }
        style={{
          ...buttonStyle,
          border:
            selectedAddressType !== addressTypes[at].type
              ? "1px solid rgb(206, 206, 206)"
              : "none",
          color: selectedAddressType !== addressTypes[at].type && "#666666",
        }}
        onClick={addressTypes[at].onClick}
      >
        {addressTypes[at].icon}
        <span
          style={{
            marginTop: 2,
            marginLeft: language === "arabic" ? 0 : 10,
            marginRight: language === "arabic" ? 10 : 0,
            fontSize: 11.5,
          }}
        >
          {language === "arabic" ? addressTypes[at].ar : at}
        </span>
      </Button>
    </div>
  ));
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-evenly",
      }}
    >
      {buttons}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};
export default connect(mapStateToProps)(AddressTypeSelectNew);
